import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function ShieldIcon(props: SVGProps<any>): ReactElement {
	return (
		<BaseIcon {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20 12c0 6-8 10-8 10s-8-4-8-10V5l8-3 8 3v7Zm-3.915-4.667a.584.584 0 1 0-1.169 0v9.333a.584.584 0 0 0 1.167 0V7.334ZM12 10.25c.323 0 .584.261.584.585v5.832a.584.584 0 0 1-1.167 0v-5.834c0-.323.261-.584.584-.584Zm-2.916 4.082a.584.584 0 1 0-1.167 0v2.334a.584.584 0 1 0 1.167 0v-2.334Z"
				fill="currentColor"
			/>
		</BaseIcon>
	);
}
